import $ from "jquery";
import gsap from "gsap";

$(document).ready(() => {
  // Animate headings and sections
  gsap.from("h1", { y: -50, opacity: 0, duration: 1, ease: "power2.out" });
  gsap.from("h2", { y: 20, opacity: 0, duration: 1, stagger: 0.3 });
  gsap.from("section", { y: 30, opacity: 0, duration: 1, stagger: 0.3, delay: 0.5 });
});
